export default __webpack_public_path__ + "static/media/slider4-2items.a2e8bace.svg";